import { signInWithEmailAndPassword } from "firebase/auth";
import { configAuth } from "../../firebaseConfig";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken, setRefreshToken, setUID } from "../../Store/slices/authSlice";
import toast from "react-hot-toast";
import { useNavigationHook } from "../useNavigationHook";
import { useTagsHook } from "./useTagsHook";

export const useAuthHook = () => {
    const [email, setEmail] = React.useState<string>('');
    const [password, setPassword] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const dispatch = useDispatch();

    const {
        navigateTo
    } = useNavigationHook();

    const {
        fetchTags,
    } = useTagsHook();

    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);

    const loginAsAdmin = async () => {
        setLoading(true);
        signInWithEmailAndPassword(configAuth, email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                //check user is admin or not
                // if admin navigate to admin page
                // else navigate to user page
                console.log("token:", user.getIdToken());

                user.getIdTokenResult()
                    .then(async (idTokenResult) => {
                        console.log("idTokenResult:", idTokenResult);
                        console.log("Refresh token:", user.refreshToken);
                        console.log("UID:", user.uid);
                        console.log("accessToken:", idTokenResult.token);
                        console.log("admin:", idTokenResult.claims.admin);
                        if (idTokenResult.claims.admin === true) {
                            console.log("User is admin");
                            toast.success("Login successful");
                            dispatch(setUID(user.uid));
                            dispatch(setAccessToken(idTokenResult.token));
                            dispatch(setRefreshToken(user.refreshToken));
                            console.log("Refresh token:", user.refreshToken);
                            await fetchTags();
                            setLoading(false);
                            setTimeout(() => {
                                navigateTo("/dashboard");
                            }, 1000);
                        } else {
                            toast.error("You are not an admin!");
                            console.log("User is not admin");
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        setLoading(false);
                    });

                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                if (errorCode === 'auth/user-not-found') {
                    toast.error("User not found");
                    setLoading(false);
                }
                else if (errorCode === 'auth/wrong-password') {
                    toast.error("Wrong password");
                    setLoading(false);
                }
                else if (errorCode === 'auth/invalid-email') {
                    toast.error("Invalid email");
                    setLoading(false);
                }
                else if (errorCode === 'auth/user-disabled') {
                    toast.error("User is disabled");
                    setLoading(false);
                }
                else if (errorCode === 'auth/too-many-requests') {
                    toast.error("Too many requests");
                    setLoading(false);
                }
                else if (errorCode === 'auth/network-request-failed') {
                    toast.error("Network request failed");
                    setLoading(false);
                }
                else if (errorCode === 'auth/invalid-credential') {
                    toast.error("Invalid credential");
                    setLoading(false);
                }
                else {
                    toast.error("Error");
                    setLoading(false);
                }
                console.log({
                    errorCode: errorCode,
                    errorMesage: errorMessage,
                })
            });

    };

    return {
        email,
        password,
        setEmail,
        setPassword,
        loginAsAdmin,
        loading,
    };

};